import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BaseApiTemplateService } from '../../shared/base-api-template-service.model';
import { Core2Config } from '../../shared/core2Config';
import { StockReplenishmentTemplateFilterSupplierModel } from '../../../../../../models/aggregates/erp/stock/stock-replenishment-template-filter-supplier.model';

@Injectable({ providedIn: 'root' })
export class StockReplenishmentTemplateFilterSupplierService extends BaseApiTemplateService<StockReplenishmentTemplateFilterSupplierModel> {
  readonly url = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + 'erp/inv-stock-replenishment-template-filter-suppliers/backoffice-ep';

  constructor(theHttp: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + 'erp/inv-stock-replenishment-template-filter-suppliers/backoffice-ep';
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + 'erp/inv-stock-replenishment-template-filter-suppliers/backoffice-ep';
    this.httpClient = theHttp;
  }

}
